
import FBSyncBase from "./FBSyncBase";
import FirebaseClient from "./FirebaseClient";
import DataSnapshot = firebase.database.DataSnapshot;
import ClassRegistry from "./ClassRegistry";
import * as _ from 'lodash';
import Hasher from "./Hasher";
import {IndexSpec} from "./IndexSpec";
const EventEmitter = require('events');
import {IHash} from "./CommonInterfaces";

let clone = require("clone");
let diff = require('deep-diff').diff;
let shortid = require('shortid');


class RegisteredObject{




	id:string; //save as object it represents
	private raw:any;
	private rawClone:any;
	valueChangeCallback:(snapshot:DataSnapshot)=>any;
	private obj:FBSyncBase;
	private dbObj:FBSyncBase;
	private callbacks:IHash<(any)=>void> = {};

	constructor(id:string){

		if(id == undefined){
			throw new Error("creating a registered object without an id");
		}

		this.id = id;
		this.setupValueChangeCallback();
	}

	addChangeCallback(cb):string{
		let id = shortid.generate();
		this.callbacks[id] = cb;
		return id;
	}

	removeChangeCallback(id:string){
		delete this.callbacks[id];
	}

	setupValueChangeCallback(){


		FBOM.setObjectLoading(this);




		//this callback will be called every time an object is changed.
		this.valueChangeCallback = (snapshot:DataSnapshot)=>{

			(async() => {

				//TODO if we are hydrating, queue up the snapshot for later, and call the value change callback after this finishes
				//TODO I thought we also needed to do this when we are loading, but we don't.
				if(FBOM.objectIsHydrating(this)){
					throw new Error("CODE NEEDED: a value change callback came in while we were hydrating, we don't support this yet")
				}




				//update the object in the registry with the new object.
				this.setObjectFromSnapshot(snapshot);


				//remove the id from loading
				FBOM.setObjectDoneLoading(this);


				let childIds = FBOM._rChildIds(this.raw);
				let needsHydration = false;
				for (let i = 0; i < childIds.length; i++) {
					let id = childIds[i];
					FBOM._loadObject(id)
				}

				FBOM.addRegisteredObjectToHydrationQueue(this);
				FBOM.hydrateObjects();
				await FBOM.awaitHydrationP();

				_.forOwn(this.callbacks, (value)=>{
					value(this.getObject());
				})

			})();



		};

		FirebaseClient.getDb().ref(`objects/${this.id}`).on('value',this.valueChangeCallback);
	}




	setObjectFromSnapshot(snapshot:DataSnapshot){

		this.raw = snapshot.val();
		this.rawClone = clone(this.raw);


		//First create the object if it hasn't been created yet.
		if(this.obj == undefined){

			this.obj = ClassRegistry.getFactory(snapshot.val().type)();
		}

		//Now copy over the snapshot data
		Object.assign(this.obj,snapshot.val());

		//Now load all child ids




	}

	getObject(){
		return this.obj;
	}

}

let emitter = new EventEmitter();
emitter.setMaxListeners(10000);


export default class FBOM{

	static objects:IHash<RegisteredObject> = {};
	static loading: IHash<RegisteredObject> = {};
	static hydrating: IHash<RegisteredObject> = {};
	static emitter = emitter;
	static registeredObjectsByCallbackId:IHash<RegisteredObject> = {};


	static isHydrating = false;


	static getObject(id:string):any{
		return (FBOM.objects[id].getObject() as any);
	}

	static onObjectChange(id:string|FBSyncBase, cb):string{
		if (typeof id != "string"){
			id = id.id;
		}

		let cbId = this.objects[id].addChangeCallback(cb);
		 FBOM.registeredObjectsByCallbackId[cbId] = this.objects[id];
		 return cbId;
	}

	static removeObjectChangeHandler(cbId:string){

		this.registeredObjectsByCallbackId[cbId].removeChangeCallback(cbId);
		delete this.registeredObjectsByCallbackId[cbId];
	}

	//TODO for now this will return non managed objects, but in the future we should manage them if the person wants.
	static getIndexEqualsP(spec:IndexSpec,value:string):Promise<any[]>{
		return (async() => {
			let snapshot = await FirebaseClient.getDb().ref('objects').orderByChild(spec.getFieldName()).equalTo(value).once('value');

			let snapVal = snapshot.val();
			let ret:any[] = [];
			_.forOwn(snapVal,(value:any)=>{
				ret.push(FBOM.createObjectFromJSON(value));
			});

			return ret;
		})();
	}





	/**
	 * Recursively saves the object.  This means it will save this object, and all of it's children which extend FBSyncBase.
	 * @param obj the object to save
	 * @param onlySaveDirty this will only save objects that are dirty, but requires more cpu to figure it out.
	 */
	static rSaveP(obj:FBSyncBase,onlySaveDirty:boolean=false){
		return (async() => {



			//first recursively find all of it's children
			let childMap = FBOM._getAllSyncObjects(obj);

			let objectsToSave = _.values(childMap);




			//TODO think about saving these all at once instead of all separate objects. THIS ACTUALLY IS PRETTY FAST SEPARATELY
			//TODO think about using a firebase transaction when you save this stuff, so if one fails, they all fail.
			let promises = objectsToSave.map((obj)=>FBOM.saveObjectP(obj,onlySaveDirty));


			let result = await Promise.all(promises);
			return;


		})();
	}


	/**
	 * Saves the object, but not any of it's children which extend FBSyncBase.
	 *
	 * @param obj the object to save
	 * @param onlySaveDirty this will only save objects that are dirty, but requires more cpu to figure it out.
	 *
	 * @returns {Promise<Promise<any>>}
	 */
	static saveObjectP(obj:FBSyncBase,onlySaveDirty:boolean=false){
		return (async() => {
			console.log('saving object: ', obj);

			obj = FBOM._prepareObjectToSave(obj);
			let json = FBOM._generateSavingJson(obj);


			let updates = {};
			updates[`/objects/${obj.id}`] = json;

			//TODO register the object and keep it here
			//TODO create an on value listener.


			await FirebaseClient.updateFromRootP(updates);
			return;
		})();
	}




	static _hydrateObjectsHelper(){

		(async() => {

			await FBOM.awaitLoadingObjectsP();


			//we are now done loading and we can hydrate.
			let objects:RegisteredObject[] = _.values(FBOM.hydrating);
			for (let i = 0; i < objects.length; i++) {
				let obj = objects[i];
				FBOM._hydrateObject(obj.getObject());
				FBOM.removeRegisteredObjectFromHydrationQueue(obj);
			}

			FBOM.emitter.emit("hydrationDone");
			FBOM.isHydrating = false;


		})();





	}

	static awaitHydrationP(){

		return new Promise((resolve, reject) => {
			if(!FBOM.isHydrating) return resolve();



			FBOM.emitter.on("hydrationDone",()=>{
				return resolve();
			});

		});
	}


	static hydrateObjects(){


		//Don't try to hydrate twice
		if(FBOM.isHydrating) return;
		FBOM.isHydrating = true;
		FBOM._hydrateObjectsHelper();

	}





	static rLoadP(id:string|FBSyncBase){
		return (async() => {
			if(id instanceof FBSyncBase) id = id.id;
			FBOM._loadObject(id);
			await FBOM.awaitLoadingObjectsP();
			await FBOM.awaitHydrationP();
			return FBOM.getObject(id);

		})();
	}



	static addRegisteredObject(obj:RegisteredObject){
		FBOM.objects[obj.id] = obj;
	}


	static setObjectLoading(obj:RegisteredObject){
		FBOM.loading[obj.id] = obj;
	}
	static isObjectLoading(id:string){
		return FBOM.loading[id] != undefined;
	}
	static setObjectDoneLoading(obj:RegisteredObject){
		delete FBOM.loading[obj.id];
	}

	static addRegisteredObjectToHydrationQueue(obj:RegisteredObject){
		FBOM.hydrating[obj.id] = obj;
	}

	static removeRegisteredObjectFromHydrationQueue(obj:RegisteredObject){
		delete FBOM.hydrating[obj.id];
	}

	static objectIsHydrating(obj:RegisteredObject){
		return FBOM.hydrating[obj.id] != undefined;
	}


	static _hydrateObject(obj:any){

		if(obj instanceof Array){

			for(let i =0; i < obj.length; i++){

				if(FBSyncBase.isId(obj[i])){
					let replacement = FBOM.getObject(obj[i]);
					if(replacement == undefined) throw new Error("error hydrating object, undefined");
					obj[i] = replacement;
				}else{
					FBOM._hydrateObject(obj[i]);
				}
			}
		}else if(typeof obj == "object"){
			_.forOwn(obj, (value:any, key:string)=> {
				if(key != 'id'){
					if(FBSyncBase.isId(value)){
						let replacement = FBOM.getObject(value);
						if(replacement == undefined) throw new Error("error hydrating object, undefined");
						obj[key] = replacement;
					}else{
						FBOM._hydrateObject(value);
					}
				}
			});
		}


	}

	static _loadObject(id:string){
		if(FBOM.objects[id] != undefined){
			return true;
		}

		//create a new registered object for this id and register it
		let regObj = new RegisteredObject(id);
		FBOM.addRegisteredObject(regObj);
		return false;
	}

	static fixedHashString(str:string){
		return Hasher.hashString(str);
	}


	static awaitLoadingObjectsP(){
		return new Promise((resolve, reject) => {

			let count = 0;
			let waitAndCheck = ()=>{

				if(Object.keys(FBOM.loading).length == 0) return resolve();



				if(count++ > 1000){
					return reject(new Error("Waiting for objects to load is not returning"));
				}
				setTimeout(waitAndCheck,10);
			};

			waitAndCheck();
		});
	}

	static createObjectFromJSON(json:any){
		let obj = ClassRegistry.getFactory(json.type)();
		Object.assign(obj,json);
		return clone(obj);
	}


	//
	// static _loadAndRegisterObjectP(id:string){
	//
	// 	return new Promise((resolve, reject) => {
	// 		if(FBOM.objects[id] != undefined){ //already exists
	//
	//
	// 			//TODO what do we want to do here, skip or reload?
	// 			return resolve();
	//
	//
	// 		}else{ //object not registered yet
	//
	// 			let haveResolved = false;
	//
	//
	// 			//create a new registered object for this id and register it
	// 			let regObj = new RegisteredObject(id);
	// 			FBOM.objects[id] = regObj;
	//
	//
	// 			//this callback will be called every time an object is changed.
	// 			//this should be moved somewhere else.
	// 			regObj.valueChangeCallback = (snapshot:DataSnapshot)=>{
	//
	//
	// 				//update the object in the registry with the new object.
	// 				regObj.setObjectFromSnapshot(snapshot);
	//
	//
	// 				//remove the id from loading
	// 				delete FBOM.loadQueue[id];
	//
	//
	// 				//TODO we need to notify any listeners that we are updated
	//
	//
	//
	// 				//so we can resolve a promise on the first return for convenience.
	// 				if(haveResolved == false){
	// 					haveResolved = true;
	// 					return resolve(regObj.getObject());
	// 				}
	// 			};
	//
	//
	//
	//
	// 			FirebaseClient.getDb().ref(`objects/${id}`).on('value',regObj.valueChangeCallback);
	//
	// 		}
	// 	});
	//
	// }




	static _rChildIds(obj:any, result?:string[]){
		if(result == undefined)result = [];

		if(obj instanceof Array){

			for(let i =0; i < obj.length; i++){
				FBOM._rChildIds(obj[i], result);
			}

		}else if(typeof obj == "object"){

			_.forOwn(obj, (value:any, key:string)=> {
				FBOM._rChildIds(value,result);
			});
		}else{
			if(FBSyncBase.isId(obj)){
				result.push(obj);
			}
		}


		return result;
	}

	static _generateSavingJson(obj:FBSyncBase){
		let working:FBSyncBase = clone(obj);
		return FBOM._generateSavingJsonHelper(Object.assign({},obj));
	}

	static _generateSavingJsonHelper(obj:any){

		if(obj instanceof FBSyncBase){
			return obj.id;
		}
		else if(obj instanceof Date){
			return obj.getTime();
		}else if(obj instanceof Array){
			let ret:any[] = [];

			for(let i =0; i < obj.length; i++){
				ret[i] = FBOM._generateSavingJsonHelper(obj[i]);
			}

			return ret;
		}
		else if(typeof obj == "object"){
			let ret = {};
			_.forOwn(obj, (value:any, key:string)=> {
				ret[key] = FBOM._generateSavingJsonHelper(value)
			});
			return ret;
		}else{
			return obj;
		}

	}

	//also returns the root object if it's a FBSyncBase subclass.
	static _getAllSyncObjects(obj:any, result?:IHash<FBSyncBase>):IHash<FBSyncBase>{
		if(result == undefined) result = {};


		//not part of the else if, we want to process this object as well
		if(obj instanceof FBSyncBase){

			//don't process the same object twice, we don't want to get into infinite recursion.
			if(result[obj.id] != undefined) return result;

			//use a hash because we don't want to store duplicates
			result[obj.id] = obj;
		}


		if(obj instanceof Array){

			for(let i =0; i < obj.length; i++){
				FBOM._getAllSyncObjects(obj[i], result);
			}

		}else if(typeof obj == "object"){

			_.forOwn(obj, (value:any, key:string)=> {
				FBOM._getAllSyncObjects(value,result);
			});
		}

		return result;
	}




	static _prepareObjectToSave(obj:FBSyncBase){
		obj.type = ClassRegistry.getTypeFromClassName(obj.constructor.name);
		let indexes = ClassRegistry.getIndexSpecs(obj.type);


		//add all the index fields.
		for (let i = 0; i < indexes.length; i++) {
			let index = indexes[i];
			obj[index.getFieldName()] = index.genIndexFromObject(obj);
		}


		return obj; //not necessary

	}

	static _generateObjectJSON(obj:FBSyncBase){
		return Object.assign({},obj);
	}
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/fbobjects/framework/FBOM.ts